export default __webpack_public_path__ + "home.phone.normal.00e3b6d86a478220318c443e67775b9b.png";